<template>
    <div>
        <div class="rounded-md bg-blue-50 p-4">
            <div class="flex">
                <div class="ml-3 flex-1 md:flex md:justify-between">
                    Расположите мессенджеры в нужном порядке - откроется первый, который будет на телефон
                    пользователя
                </div>
            </div>
        </div>

        <draggable
            v-model="fields.items"
            group="messengers"
            item-key="type"
            @start="drag=true"
            @end="drag=false"
        >
            <template #item="{element}">
                <div class="bg-white overflow-hidden shadow rounded-lg mt-2">
                    <div class="px-4 py-5 sm:p-6">
                        <div class="flex mb-2 justify-between">
                            <div class="flex">
                                <div class="mr-2 font-bold">{{ element.type }}</div>
                                <div>
                                    <input v-model="element.checked"
                                           type="checkbox"
                                           class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"/>
                                </div>
                            </div>

                            <Bars4Icon class="h-5 w-5 text-gray-200" aria-hidden="true"/>
                        </div>
                        <div>
                            <div>
                                <div class="flex justify-between">
                                    <label for="phone" class="block text-sm font-medium text-gray-700">Телефон</label>
                                </div>
                                <div class="mt-1">
                                    <input required v-model="element.phone" type="text" name="phone" id="phone"
                                           class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                           placeholder=""/>
                                </div>
                            </div>

                            <div class="mt-2">
                                <div class="flex justify-between">
                                    <label for="body" class="block text-sm font-medium text-gray-700">Сообщение</label>
                                </div>
                                <div class="mt-1">
                    <textarea required v-model="element.text" type="text" name="body" id="body"
                              class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                              placeholder=""/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </draggable>

        <div class="bg-white overflow-hidden shadow rounded-lg mt-2">
            <div class="px-4 py-5 sm:p-6">
                <div class="flex mb-2 justify-between">
                    <div>
                        <div class="mr-2 font-bold">Что делать, если мессенджеров у пользователя нет?</div>
                        <div class="mt-2">
                            <v-select class="without-ring" :searchable="false" :clearable="false" :reduce="el => el.type"
                                      :options="this.fallbackOptions" v-model="fields.fallback.type">
                            </v-select>
                        </div>
                    </div>
                </div>
                <div>
                    <div v-if="fields.fallback.type === 'sms'">
                        <div class="flex justify-between">
                            <label for="phone" class="block text-sm font-medium text-gray-700">Телефон</label>
                        </div>
                        <div class="mt-1">
                            <input required v-model="fields.fallback.phone" type="text" name="phone" id="phone"
                                   class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                   placeholder=""/>
                        </div>
                    </div>

                    <div class="mt-2">
                        <div class="flex justify-between">
                            <label for="body" class="block text-sm font-medium text-gray-700">Сообщение</label>
                        </div>
                        <div class="mt-1">
                    <textarea required v-model="fields.fallback.text" type="text" name="body" id="body"
                              class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                              placeholder=""/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Bars4Icon} from '@heroicons/vue/24/outline'
import {mapActions, mapState} from "pinia";
import {qrCodeFormStore} from "@/scripts/store/qr_code_form.store";
import VueShortToggle from "@/scripts/components/app/common/vue-short-toggle.vue";
import draggable from 'vuedraggable'
import {CheckCircleIcon} from "@heroicons/vue/24/solid";
import vSelect from "vue-select";

export default {
    components: {
        vSelect,
        CheckCircleIcon,
        VueShortToggle,
        draggable,
        Bars4Icon
    },
    props: {
        destinationId: {
            required: true
        }
    },

    data() {
        return {
            myList: [],
            drag: false,
            fallbackOptions: [
                {label: 'Использовать смс', type: 'sms'},
                {label: 'Показать текст', type: 'text'},
            ]
        }
    },

    computed: {
        ...mapState(qrCodeFormStore, ['code']),
        fields: {
            get() {
                return this.code.destinations[this.destinationId].data
            },
            set(val) {
                this.updateDestinationData(this.destinationId, val)
            }
        }
    },

    methods: {
        ...mapActions(qrCodeFormStore, ['updateDestinationData'])
    }
}
</script>

<style lang="scss">
.v-select {
    input {
        all: initial;
    }
}
</style>